<template>
  <div class="goods_model">
    <baseModal
      width="830px"
      title="商品库"
      @sureFun="confirmgoods"
      @cancalFun="goodsModelShow = false"
      :dialogVisible="goodsModelShow"
    >
      <template #content="scope">
        <baseSearch :list="searchFrom" @search="searchFun"> </baseSearch>
        <baseSelectTable
          ref="baseSelectTable"
          :loading="search.loading"
          :total="search.total"
          :page="search.post.page"
          :pagesize="search.post.limit"
          :list="search.table"
          :tableList="search.tableForm"
          :selection="true"
          @changePage="changePage"
          @tableSelectionChange="tableSelectionChange"
        >
          <!--商品信息 -->
          <template #goods_info="scope">
            <div class="goods_item">
              <div class="imgbox">
              <img :src="scope?.row?.goods_image||require('@/static/img/empty_img.png')"  alt="" />
              </div>
              <div class="goods_item_box">
                <div class="name">{{ scope.row.goods_name }}</div>
              </div>
            </div>
          </template>
          <!-- 状态 -->
          <template #status="scope">
            <el-tag :type="scope.row.status == '10' ? 'success' : ''">{{
              scope.row.status == "10" ? "上架" : "下架"
            }}</el-tag>
          </template>
        </baseSelectTable>
      </template>
    </baseModal>
  </div>
</template>
<script>
import baseSearch from "@/components/common/baseSearch.vue";
import baseSelectTable from "./baseSelectTable.vue";
import baseModal from "@/components/common/baseModal.vue";
import { eltips } from "@/util/util.js";
import { resolveWeiShopApi } from "@/views/apps/weishop/region/utils/regionApiMap";

export default {
	name:'LiveModal',
  components: {
    baseModal,
    baseSearch,
    baseSelectTable,
  },
  data() {
    return {
      search: {
        post: {
          page: 1,
          limit: 5,
          goodsName: "",
          categoryId: "",
        },
        loading: false,
        total: 0,
        tableForm: [
          { label: "ID", prop: "id", width: 70 },
          { label: "直播间名称", prop: "name", width: 310 },
          { label: "开始时间", prop: "start_time"  },
          { label: "结束时间", prop: "end_time" },
          // { label: "状态", prop: "status", width: 110 },
        ],
        table: [],
      },
      searchFrom: [
        {
          type: "selection",
        },
        {
          type: "input",
          Field: "keyword",
          label: "关键字",
          style: {
            width: "130px",
          },
          placeholder: "请输入关键字",
        },
      ],
      goodsModelShow: false,
      selectedItems: [],
      selectedRowKeys: [],
    };
  },
  created() {
    // 获取商品列表
    this.getGoodsList();
  },
  methods: {
    // 切换页数
    changePage(e) {
      this.search.post.page = e;
      this.getGoodsList();
    },
    // 筛选方法
    searchFun(e) {
      let _this = this;
      _this.search.post.goodsName = e.goodsName;
      _this.search.post.categoryId = e.categoryId;
      this.getGoodsList();
    },
    // 打开商品库
    handle(data) {
      if (data) {
        data=data.map((item)=>{
          return{
            ...item,
            id:item.goods_id
          }
        })
        this.$nextTick(() => {
          this.$refs.baseSelectTable.updateSelectedMap(data);
        });
      }

      this.goodsModelShow = true;
    },
    // 关闭商品库并返回数据
    handleCancel() {
      this.goodsModelShow = false;
    },
    confirmgoods() {
      this.$refs.baseSelectTable.changepage();
      const data = this.$refs.baseSelectTable.getAllSelections();
	  console.log("data",data)
      this.$emit("handleSubmit", {
        selectedItems: data,
      });

      this.handleCancel();
    },
    // 获取当前被选中商品的数据
    tableSelectionChange(e) {
		console.log(e)
      this.selectedItems = e;
    },
    // 商品列表
    getGoodsList() {
      let _this = this;
      _this.search.loading = true;
      _this.axios
        .get(resolveWeiShopApi("/api/shop/basic/wechat/live_stream/index"), {
          params: {
            ..._this.search.post,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            _this.search.table = res.data.data.map((item) => {
              return {
                ...item,
                id: item.id,
              };
            });
            _this.search.total = res.data.total;
          } else {
            eltips(res.msg, "error");
          }
          _this.search.loading = false;
        });
    },
    // 商品分类列表
    getCategoryList() {
      let _this = this;
      _this.axios.get(resolveWeiShopApi("/api/weishop/admin/category/list")).then((res) => {
        if (res.code == 200) {
          _this.searchFrom[2].options = _this.addIdAsValueToTree(res.data);
        } else {
          eltips(res.msg, "error");
        }
      });
    },
    addIdAsValueToTree(tree) {
      // 递归函数遍历树形结构并修改每个节点
      function transformTree(node) {
        // 给当前节点添加新属性 'value'，其值为 'id'
        node.value = node.category_id;
        node.label = node.name;
        // 如果当前节点有子节点，递归调用 transformTree
        if (node.children) {
          node.children.forEach((child) => transformTree(child));
        }
      }
      // 对每个根节点进行递归操作
      tree.forEach((node) => transformTree(node));

      // 返回修改后的树
      return tree;
    },
  },
};
</script>
<style lang="less" scoped>
.goods_item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 20px;
  text-align: left;
  .imgbox{
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    margin-right: 10px;
  }
  img{
    width: 100%;
    height: 100%;
  }
  .name {
    margin-left: 5px;
  }
}
/deep/.el-table th,
.el-table td {
  padding: 0;
}
/deep/ .el-dialog__body {
  padding: 0 20px !important;
}
/deep/.searchHead484848 {
  padding: 10px 0;
  margin-left: -19px;
}
/deep/.dialog-footer {
  padding-top: 0;
}
/deep/.el-table th > .cell {
  font-weight: 500;
}
/deep/.dialog-footer {
  padding-top: 10px;
}
</style>
